import { BillingAccount } from 'app/page/orders/model/billing-account';

class BillingAccountMapper {
    public static mapBillingAccount(billingAccount: OrderTrackerBackend.BillingAccount): BillingAccount {
        return {
            partnerId: billingAccount.partnerId,
            accountId: billingAccount.accountId,
            initialized: false,
            activeOrders: {},
        };
    }
}

export { BillingAccountMapper };
